import React__default from 'react';
import { Dialog, Logo } from '@sravni/react-design-system';
import { AuthForm } from '@sravni/react-silent-authentication-form';
import modules_3d2af0d9 from './auth-popup.module.scss.js';
import { AuthType } from './types/index.js';
import { USER_MANAGER_BY_AUTH_TYPE } from './utils/userManager.js';

const AuthPopup = React__default.forwardRef((props, ref) => {
    const { isVisible, onClose, onLogin, authType = AuthType.Default, ...rest } = props;
    return (React__default.createElement(Dialog, { visible: isVisible, onClose: onClose, className: modules_3d2af0d9.popup },
        React__default.createElement(Dialog.Header, { className: modules_3d2af0d9.header, title: React__default.createElement(Logo, null) }),
        React__default.createElement(Dialog.Content, null,
            React__default.createElement(AuthForm, { userManager: USER_MANAGER_BY_AUTH_TYPE[authType], ref: ref, onLogin: onLogin, enableAutoSubmit: true, ...rest }))));
});

export { AuthPopup };
//# sourceMappingURL=AuthPopup.js.map
